import {default as UUID} from "node-uuid";

export default function getID( key: string = ""): string {
    return ( key || ( new Date() ).getTime().toString() ).replaceAll( "_", "-" ) + "-" + UUID.v4().substring(0, 10) 
}